import { render } from "./Car.vue?vue&type=template&id=6081c2bc&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

import "./Car.vue?vue&type=style&index=0&id=6081c2bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6081c2bc"],['__file',"src/views/v3/Car.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6081c2bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6081c2bc', __exports__)) {
    api.reload('6081c2bc', __exports__)
  }
  
  module.hot.accept("./Car.vue?vue&type=template&id=6081c2bc&scoped=true", () => {
    api.rerender('6081c2bc', render)
  })

}


export default __exports__